
const generateBottleImageMarkup = (stepIndex:number) => {
  return `
    <style>

      .bundle-bottle-image {}

      .bottle-placeholder {
        width: 100%;
        height: 100%;
        position: relative;
      }

      .placeholder-image {
        width: 12.42vw;
        height: auto;
        margin: 0 12px
      }

      .step-number {
        display: block;
        height: 1.5rem;
        width: 1.5rem;
        border: 1px solid #fff;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }


      .step-number::before {
        content: '+';
        font-family: var(--font-secondary) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        margin-top: -0.125rem;
      }

      .selected-bottle-image {
        width: 22vw;
        height: auto;
        display: none;
      }

      .bundle-bottle-image.is-current-step {

      }

      .bundle-bottle-image.is-current-step .step-number::before {
        content: '${stepIndex + 1}';
        font-family: var(--font-secondary);
        font-size: 0.75rem !important;
        line-height: 1rem !important;
        letter-spacing: 0.135rem !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        margin-top: 0 !important;
      }

      .bundle-bottle-image.has-bottle-selected .bottle-placeholder { display: none; }
      .bundle-bottle-image.has-bottle-selected .selected-bottle-image { display: block; }


      @media screen and (min-width: 767px) {
        .placeholder-image {
          width: 8.42vw;
          height: auto;
        }

        .selected-bottle-image {
          width: 16vw;
        }
      }

      @media screen and (min-width: 991px) {
        .placeholder-image {
          width: 6vw !important;
          height: auto !important;
        }

        .selected-bottle-image {
          width: 13.2vw;
        }

        .has-glass.selected-bottle-image {

        }
      }

    </style>
    <div class="bundle-bottle-image" part="bottle-image">
      <div class="bottle-placeholder">
        <img class="placeholder-image" src="https://cdn.shopify.com/s/files/1/0492/9857/1425/files/bottle_foam.png?v=1694064433">
        <span class="step-number"><span>
      </div>

      <img class="selected-bottle-image" src="">
    </div>
  `
}

export class BundleBottleImage extends HTMLElement {

  private readonly root:HTMLDivElement;
  private selectedBottleImage:HTMLImageElement;

  private readonly stepIndex:number = parseInt(this.getAttribute('step-index') || '');


  private hasImageSet:boolean = false;
  private isActive:boolean = false;
  private imageSrc:string = '';

  constructor() {
    super();

    const template = document.createElement('template');
    template.innerHTML = generateBottleImageMarkup(this.stepIndex)
    // Attach shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    // Query things
    this.root = shadowRoot.querySelector('.bundle-bottle-image')!;
    this.selectedBottleImage = shadowRoot.querySelector('.selected-bottle-image')!;
    this.addEventListener('click', this.handleClickEvent);
  }

  public setHasGlass(hasGlass:boolean) {
    this.root.classList[hasGlass ? 'add' : 'remove']('has-glass')
  }

  private handleClickEvent() {
    const event = new CustomEvent('navigation', { 
      detail: { stepIndex: this.stepIndex }, 
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }

  public setActive(isActive:boolean) {
    this.isActive = isActive;
    this.root.classList[this.isActive ? 'add' : 'remove']('is-current-step')
  }

  public setImageSrc(imageSrc:string|null) {
    this.hasImageSet = !!imageSrc;
    this.imageSrc = imageSrc ?? '';

    this.selectedBottleImage.src = this.imageSrc;
    this.root.classList[this.hasImageSet ? 'add' : 'remove']('has-bottle-selected')
  }
}

if(!customElements.get('bundle-bottle-image')) {
  customElements.define('bundle-bottle-image', BundleBottleImage);
}